import { createSvgComponent } from "../../icon/createSvgComponent";
import Refresh from "@core/__generated__/icon/figma/refresh.svg";
export default createSvgComponent(Refresh);